import CardContainer from "../generic/CardContainer";
import InfoCard from "../generic/InfoCard";
import MusicPage from "./MusicPage";

interface Props {}

function HomePage(props: Props) {
  // const {} = props

  return (
    <CardContainer>
      <InfoCard>
        <div className="centered-list-of-stuff">
          <div>Curtis Voorhees is a singer/songwriter based out of Weare NH.</div>
          <p>He performs a mix of original songs and covers in a unique steel-string fingerpicking style.</p>
        </div>
      </InfoCard>
      <MusicPage />
    </CardContainer>
  );
}

export default HomePage;
